// commenting 3, 5, 33 as we don't want them in onboard intent
export const LIFECYCLE_DEMO_EMPLOYEES = {
  '1': {
    name: 'Alex Spencer',
    email: '8@lonbjx.com',
    img: 'https://media.mesh.ai/2415/media/profilePhoto/50723/2023/01/06/50723.jpg_1673027618924',
  },
  '2': {
    name: 'Bianca Hardy',
    email: '16@lonbjx.com',
    img: 'https://media.mesh.ai/2415/media/profilePhoto/50716/2023/01/06/50716.jpg_1673027564171',
  },
  // '3': {
  //   name: 'Bruce Salem',
  //   email: '7@lonbjx.com',
  //   img: 'https://media.mesh.ai/2415/media/profilePhoto/50724/2023/01/06/50724.jpg_1673027627036',
  // },
  '4': {
    name: 'Carlos Jiron',
    email: '20@lonbjx.com',
    img: 'https://media.mesh.ai/2415/media/profilePhoto/50700/2023/01/06/50700.jpg_1673027566718',
  },
  // '5': {
  //   name: 'Chloe Nunez',
  //   email: '9@lonbjx.com',
  //   img: 'https://media.mesh.ai/2415/media/profilePhoto/50721/2023/01/06/50721.jpg_1673027588228',
  // },
  '6': {
    name: 'Dai Long',
    email: '15@lonbjx.com',
    img: 'https://media.mesh.ai/2415/media/profilePhoto/50715/2023/01/06/50715.jpg_1673027571813',
  },
  '7': {
    name: 'Ged Frost',
    email: '24@lonbjx.com',
    img: 'https://media.mesh.ai/2415/media/profilePhoto/50709/2023/01/06/50709.jpg_1673027575066',
  },
  '8': {
    name: 'George Weber',
    email: '29@lonbjx.com',
    img: 'https://media.mesh.ai/2415/media/profilePhoto/50720/2023/01/06/50720.jpg_1673027560850',
  },
  '9': {
    name: 'Giulia Mancini',
    email: '18@lonbjx.com',
    img: 'https://media.mesh.ai/2415/media/profilePhoto/50714/2023/01/06/50714.jpg_1673027577544',
  },
  '10': {
    name: 'Hattie Cooper',
    email: 'demo+hattiecooper@mesh.ai',
    img: 'https://media.mesh.ai/mesh/media/profilePhoto/defaultImages/defaultPhoto-18.png',
  },
  '11': {
    name: 'Hattie Cooper',
    email: '3@lonbjx.com',
    img: 'https://media.mesh.ai/2415/media/profilePhoto/50702/2023/01/06/50702.jpg_1673027580262',
  },
  '12': {
    name: 'Helen Mirren',
    email: 'demo@mesh.ai',
    img: 'https://media.mesh.ai/2415/media/profilePhoto/50701/2023/01/06/50701.jpg_1673027582998',
  },
  '13': {
    name: 'Inika Dhingra',
    email: '13@lonbjx.com',
    img: 'https://media.mesh.ai/2415/media/profilePhoto/50704/2023/01/06/50704.jpg_1673027585543',
  },
  '14': {
    name: 'Jane Foster',
    email: '26@lonbjx.com',
    img: 'https://media.mesh.ai/2415/media/profilePhoto/50710/2023/01/06/50710.jpg_1673027590735',
  },
  '15': {
    name: 'Jane Foster',
    email: 'demo+janefoster@mesh.ai',
    img: 'https://media.mesh.ai/mesh/media/profilePhoto/defaultImages/defaultPhoto-27.png',
  },
  '16': {
    name: 'Jasper Daniels',
    email: '11@lonbjx.com',
    img: 'https://media.mesh.ai/2415/media/profilePhoto/50706/2023/01/06/50706.jpg_1673027593271',
  },
  '17': {
    name: 'Jay Chandra',
    email: '28@lonbjx.com',
    img: 'https://media.mesh.ai/2415/media/profilePhoto/50711/2023/01/06/50711.jpg_1673027596014',
  },
  '18': {
    name: 'Joshua Fernandez',
    email: '6@lonbjx.com',
    img: 'https://media.mesh.ai/2415/media/profilePhoto/50722/2023/01/06/50722.jpg_1673027598574',
  },
  '19': {
    name: 'Mark Clarke',
    email: 'demo+markclarke@mesh.ai',
    img: 'https://media.mesh.ai/mesh/media/profilePhoto/defaultImages/defaultPhoto-9.png',
  },
  '20': {
    name: 'Mark Clarke',
    email: '12@lonbjx.com',
    img: 'https://media.mesh.ai/2415/media/profilePhoto/50705/2023/01/06/50705.jpg_1673027601109',
  },
  '21': {
    name: 'Mark Kasumi',
    email: '19@lonbjx.com',
    img: 'https://media.mesh.ai/2415/media/profilePhoto/50717/2023/01/06/50717.jpg_1673027603719',
  },
  '22': {
    name: 'Ming Ye',
    email: '23@lonbjx.com',
    img: 'https://media.mesh.ai/2415/media/profilePhoto/50718/2023/01/06/50718.jpg_1673027569324',
  },
  '23': {
    name: 'Moira Porter',
    email: '10@lonbjx.com',
    img: 'https://media.mesh.ai/2415/media/profilePhoto/50699/2023/01/06/50699.jpg_1673027606170',
  },
  '24': {
    name: 'Nikhil Bhat',
    email: '14@lonbjx.com',
    img: 'https://media.mesh.ai/2415/media/profilePhoto/50703/2023/01/06/50703.jpg_1673027608662',
  },
  '25': {
    name: 'Patrick Stewart',
    email: '25@lonbjx.com',
    img: 'https://media.mesh.ai/2415/media/profilePhoto/50719/2023/01/06/50719.jpg_1673027611227',
  },
  '26': {
    name: 'Rahul Kapadia',
    email: '22@lonbjx.com',
    img: 'https://media.mesh.ai/2415/media/profilePhoto/50708/2023/01/06/50708.jpg_1673027613729',
  },
  '27': {
    name: 'Sally Preston',
    email: '17@lonbjx.com',
    img: 'https://media.mesh.ai/2415/media/profilePhoto/50713/2023/01/06/50713.jpg_1673027616291',
  },
  '28': {
    name: 'Sibley Bourn',
    email: '27@lonbjx.com',
    img: 'https://media.mesh.ai/2415/media/profilePhoto/50695/2023/01/06/50695.jpg_1673027621626',
  },
  '29': {
    name: 'Sibley Bourne',
    email: 'demo+sibleybourne@mesh.ai',
    img: 'https://media.mesh.ai/mesh/media/profilePhoto/defaultImages/defaultPhoto-25.png',
  },
  '30': {
    name: 'Simon Fisher',
    email: 'demo+simonfisher@mesh.ai',
    img: 'https://media.mesh.ai/mesh/media/profilePhoto/defaultImages/defaultPhoto-15.png',
  },
  '31': {
    name: 'Sophia Benson',
    email: '2@lonbjx.com',
    img: 'https://media.mesh.ai/2415/media/profilePhoto/50698/2023/01/06/50698.jpg_1673027624263',
  },
  '32': {
    name: 'Team Mesh',
    email: 'mesh@lonbjx.com',
    img: 'https://media.mesh.ai/mesh/media/profilePhoto/defaultImages/defaultPhoto-25.png',
  },
  // '33': {
  //   name: 'Troy Carpenter',
  //   email: '5@lonbjx.com',
  //   img: 'https://media.mesh.ai/2415/media/profilePhoto/50712/2023/01/06/50712.jpg_1673027629546',
  // },
  '34': {
    name: 'Ulric Clayton',
    email: '1@lonbjx.com',
    img: 'https://media.mesh.ai/2415/media/profilePhoto/50697/2023/01/06/50697.jpg_1673027632063',
  },
  '35': {
    name: 'Yevgeniya Vinogradova',
    email: '21@lonbjx.com',
    img: 'https://media.mesh.ai/2415/media/profilePhoto/50707/2023/01/06/50707.jpg_1673027634925',
  },
};
